import React from "react";
import { Space, Tag } from "antd";
import { StarFilled } from "@ant-design/icons";

import {
    getSongTitleInfoByID,
    getSongGenreBySongID,
    getSongStarsBySongID,
} from "../SongData";

import DifficultyTag from "../DifficultyTag";
import Crown from "../Crown";
import Badge from "../Badge";

const stripchar = require("stripchar").StripChar;

const numberWithCommas = (int) => {
    const string = int.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return (
        <span
            style={{
                whiteSpace: "nowrap",
            }}
        >
            {string}
        </span>
    );
};

// const formatTime = (timeString) => {
//     // Format from DD_MM_YY-HH_MM_SS to DD/MM/YY HH:MM:SS
//     const dateTime = timeString.split("-");
//     const date = dateTime[0].split("_");
//     const time = dateTime[1].split("_");

//     return `20${date[2]}-${date[1]}-${date[0]} ${time[0]}:${time[1]}:${time[2]}`;
// };

export const columns = (language) => {
    return [
        {
            title: "Genre",
            dataIndex: "song_id",
            key: "song_genre",
            width: "120px",
            align: "center",
            sorter: (a, b) => {
                const genreA = getSongGenreBySongID(a.song_id).title;
                const genreB = getSongGenreBySongID(b.song_id).title;
                const titleA =
                    language === "en"
                        ? stripchar.RSspecChar(
                              getSongTitleInfoByID(a.song_id, language).title
                          )
                        : getSongTitleInfoByID(a.song_id, language).title;
                const titleB =
                    language === "en"
                        ? stripchar.RSspecChar(
                              getSongTitleInfoByID(b.song_id, language).title
                          )
                        : getSongTitleInfoByID(b.song_id, language).title;

                if (genreA < genreB) {
                    return -1;
                } else if (genreA > genreB) {
                    return 1;
                } else {
                    if (titleA.toLowerCase() < titleB.toLowerCase()) {
                        return -1;
                    } else if (titleA.toLowerCase() > titleB.toLowerCase()) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            },
            render: (song_id) => {
                const { title, color } = getSongGenreBySongID(song_id);

                return (
                    <Space>
                        <Tag color={color}>{title}</Tag>
                    </Space>
                );
            },
        },
        {
            title: "Song Title",
            dataIndex: "song_id",
            key: "song_title",
            width: "25%",
            sorter: (a, b) => {
                const titleA =
                    language === "en"
                        ? stripchar.RSspecChar(
                              getSongTitleInfoByID(a.song_id, language).title
                          )
                        : getSongTitleInfoByID(a.song_id, language).title;
                const titleB =
                    language === "en"
                        ? stripchar.RSspecChar(
                              getSongTitleInfoByID(b.song_id, language).title
                          )
                        : getSongTitleInfoByID(b.song_id, language).title;

                if (titleA.toLowerCase() < titleB.toLowerCase()) {
                    return -1;
                } else if (titleA.toLowerCase() > titleB.toLowerCase()) {
                    return 1;
                } else {
                    return 0;
                }
            },
            render: (song_id) => {
                const title = getSongTitleInfoByID(song_id, language);

                return (
                    <>
                        <span
                            style={{
                                fontSize: "16px",
                                display: `block`,
                                lineHeight: `normal`,
                                marginBottom: `4px`,
                            }}
                        >
                            {title.title}
                        </span>
                        <span
                            style={{
                                fontSize: "11px",
                                lineHeight: `normal`,
                                display: `block`,
                            }}
                        >
                            {title.subtitle}
                        </span>
                    </>
                );
            },
        },
        {
            title: "Course",
            dataIndex: "difficulty",
            key: "difficulty",
            width: "75px",
            align: "center",
            sorter: (a, b) => {
                const titleA =
                    language === "en"
                        ? stripchar.RSspecChar(
                              getSongTitleInfoByID(a.song_id, language).title
                          )
                        : getSongTitleInfoByID(a.song_id, language).title;
                const titleB =
                    language === "en"
                        ? stripchar.RSspecChar(
                              getSongTitleInfoByID(b.song_id, language).title
                          )
                        : getSongTitleInfoByID(b.song_id, language).title;

                if (a.difficulty < b.difficulty) {
                    return -1;
                } else if (a.difficulty > b.difficulty) {
                    return 1;
                } else {
                    if (titleA.toLowerCase() < titleB.toLowerCase()) {
                        return -1;
                    } else if (titleA.toLowerCase() > titleB.toLowerCase()) {
                        return 1;
                    } else {
                        return 0;
                    }
                }
            },
            render: (difficulty) => <DifficultyTag difficulty={difficulty} />,
        },
        {
            title: <StarFilled />,
            dataIndex: null,
            key: "stars",
            width: "50px",
            align: "center",
            render: (e, record) => {
                const stars = getSongStarsBySongID(record);

                return (
                    <Space>
                        <span>
                            <StarFilled
                                style={{
                                    color: "#ccc",
                                }}
                            />{" "}
                            {stars}
                        </span>
                    </Space>
                );
            },
        },
        {
            title: "Crown",
            dataIndex: "crown",
            key: "crown",
            width: "75px",
            align: "center",
            sorter: (a, b) => {
                if (a.crown < b.crown) {
                    return -1;
                } else if (a.crown > b.crown) {
                    return 1;
                } else {
                    return 0;
                }
            },
            render: (crown) => <Crown crown={crown} />,
        },
        {
            title: "Rank",
            dataIndex: "scorerank",
            key: "scorerank",
            width: "75px",
            align: "center",
            render: (scorerank) => <Badge rank={scorerank} />,
        },
        {
            title: "Score",
            dataIndex: "score",
            key: "score",
            width: "75px",
            align: "center",
            sorter: (a, b) => {
                if (a.score < b.score) {
                    return -1;
                } else if (a.score > b.score) {
                    return 1;
                } else {
                    return 0;
                }
            },
            render: (score) => numberWithCommas(score),
        },
        {
            title: "Good",
            dataIndex: "good",
            key: "good",
            width: "70px",
            align: "center",
            render: (good) => numberWithCommas(good),
        },
        {
            title: "OK",
            dataIndex: "ok",
            key: "ok",
            width: "70px",
            align: "center",
            render: (ok) => numberWithCommas(ok),
        },
        {
            title: "Bad",
            dataIndex: "bad",
            key: "bad",
            width: "70px",
            align: "center",
            render: (bad) => numberWithCommas(bad),
        },
        {
            title: "Drumroll",
            dataIndex: "drumroll",
            key: "drumroll",
            width: "75px",
            align: "center",
            render: (drumroll) => numberWithCommas(drumroll),
        },
        {
            title: "Max Combo",
            dataIndex: "combo",
            key: "combo",
            width: "70px",
            align: "center",
            render: (combo) => numberWithCommas(combo),
        },
        // {
        //     title: "Date & Time",
        //     dataIndex: "dateTime",
        //     key: "dateTime",

        //     render: (text, record) => {
        //         console.log("record: ", record);
        //         let parsedDateTime = formatTime(record.dateTime);

        //         let dateObj = new Date(parsedDateTime);

        //         console.log("parseDateTime: ", parsedDateTime);
        //         console.log("dateObj: ", dateObj);

        //         return <span>{dateObj.toString()}</span>;
        //     },
        // },
    ];
};
